module.exports = {
      id: "slider-next-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#slider-next",
      toString: function () {
        return this.url;
      }
    }